import React from "react";
import { ScContainerWide } from "./styled";

interface ContainerWideProps {
  style?: React.CSSProperties;
  className?: string;
}

export const ContainerWide: React.FC<ContainerWideProps> = ({
  style,
  className = "",
  children,
}) => {
  return (
    <ScContainerWide className={className} style={style}>
      {children}
    </ScContainerWide>
  );
};
